window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.casinoMaratonHappyHourRepo = function () {

    var url = 'api/casinomaratonhappyhour';

    var get = function (sveRezultate, nadimak, lmsRezultate) {

        return fetch(url + casino.repos.base.serializeGetParams({
                sveRezultate: sveRezultate,
                nadimak: nadimak || '',
                lmsRezultate: lmsRezultate
            }), {
                credentials: repos.base.credentials
            })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        get: get
    }

}();